import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import ids from '../../QestIds';
import { MeasurementsSection } from '../Sections';
import { BsEnIsoDryMassesSection, BsEnIsoPreparationSection, BsEnIsoResultsSection } from './Sections';

const qestIds = [ids.moistureContent.BS_EN_ISO_17892_1.rev2014];

const BsEnIsoMoistureContentWorksheet: WorksheetRootComponent = () => (
  <>
    <PageSection heading="Preparation">
      <BsEnIsoPreparationSection />
    </PageSection>

    <PageSection heading="Measurements">
      <MeasurementsSection />
    </PageSection>

    <PageSection>
      <WorksheetTestedBySection />
    </PageSection>

    <PageSection heading="Dry Mass">
      <BsEnIsoDryMassesSection />
    </PageSection>

    <WorksheetResultsSection heading="Results">
      <BsEnIsoResultsSection />
    </WorksheetResultsSection>

    <PageSection heading="Images and Remarks">
      <WorksheetImagesAndRemarksSection />
    </PageSection>
  </>
);

BsEnIsoMoistureContentWorksheet.qestIds = qestIds;

export default BsEnIsoMoistureContentWorksheet;
export { BsEnIsoMoistureContentWorksheet };
